import { EmergencyNotice, EmergencyNoticeType } from './types'

const MOCK_STORAGE_KEY = 'emergencyNoticeMock'

const resolveMockType = (): EmergencyNoticeType | null => {
  if (typeof window === 'undefined') return null

  const params = new URLSearchParams(window.location.search)
  const queryMock = params.get('emergencyMock')
  const storageMock = window.localStorage.getItem(MOCK_STORAGE_KEY)
  const value = queryMock ?? storageMock

  if (value === 'notice') return 'notice'
  if (value === 'maintenance') return 'maintenance'
  return null
}

export const getMockEmergencyNotice = (): EmergencyNotice | null => {
  const type = resolveMockType()
  if (!type) return null

  const now = Math.floor(Date.now() / 1000)
  const isNotice = type === 'notice'

  return {
    idx: isNotice ? 9001 : 9002,
    type,
    title: isNotice ? '긴급알림' : '긴급 서버 점검',
    message: isNotice
      ? '<strong>서비스 이용 중 확인이 필요한 긴급 공지입니다.</strong><br />자세한 내용은 공지사항을 확인해 주세요.'
      : '안정적인 서비스 제공을 위해 <strong>시스템 점검</strong>을 진행 중입니다.<br />잠시 후 다시 접속해 주세요.',
    startAt: now - 60,
    endAt: now + 60 * 30,
    status: 'active',
    priority: 100,
  }
}
